/**
 * @module core/aspects
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * @preferred
 *
 */ /** */
import { NgModule } from '@angular/core';
import { LoggerAspect } from '@core/aspects/logger/logger-aspect';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { LoggerService } from '@core/logger/services/logger.service';

/**
 * Pseudo module to instantiate static dependencies for the child aspects
 * in this module.
 * @export
 * @class AspectsModule
 */
@NgModule({})
export class AspectsModule {
  constructor(
    private loggerService: LoggerService,
    objectService: ObjectService
  ) {
    LoggerAspect.isLoggerEnable = false;
    LoggerAspect.logger = loggerService;
    LoggerAspect.objectService = objectService;
  }
}
